import React from 'react';
import PropTypes from 'prop-types';

import SeoPageContext from 'components/SeoPage/SeoPageContext';
import useSeoPageState from 'components/SeoPage/useSeoPageState';

const SeoPageProvider = ({ children, disabledRoutes = null }) => {
  const state = useSeoPageState({ disabledRoutes });

  return <SeoPageContext.Provider value={state}>{children}</SeoPageContext.Provider>;
};

SeoPageProvider.propTypes = {
  children: PropTypes.node,
  disabledRoutes: PropTypes.arrayOf(PropTypes.string),
};

export default SeoPageProvider;
